import * as React from "react";
import { Table, SortableTableHeader } from "soprasteria-ui-library";
import { IPatientsListing } from "../../../models/IPatientsListings";
import { dateTimeToDateString } from "../../../helpers/DateHelper";
import { Link } from "react-router-dom";
import { PATIENT } from "../../../utils/RouteConstants";
import { formatPersonalSecurityNumberAndOrganisationNumber } from "../../../helpers/PersonalSecurityNumberAndOrganisationNumberHelper";

interface IPatientsListingsTable {
    data: IPatientsListing[] | undefined;
    id: string;
}

export const PatientsListingsTable: React.FunctionComponent<IPatientsListingsTable> = ({ data, id }) => {

    const goToPatientLink = (text: string, patientGuidId: string) => {
        return (
            <Link to={`/${PATIENT}/${patientGuidId}`}>{text}</Link>
        )
    }

    return (
        <>
            {
                data !== undefined ?
                    <section id={id}>
                        <Table hoverableRows={data.length > 0}>
                            <thead>
                                <tr>
                                    <SortableTableHeader propertyToSortBy="Patient.PersonalSecurityId" headerText="Personnummer" />
                                    <SortableTableHeader propertyToSortBy="Patient.FirstName" headerText="Namn" />
                                    <SortableTableHeader propertyToSortBy="Patient.Address.AddressRow" headerText="Adress" />
                                    <th>Vårdrapport påbörjad</th>
                                    <SortableTableHeader propertyToSortBy="ListingDate" headerText="Datum Listning" />
                                    <SortableTableHeader propertyToSortBy="RevisionEndDate" headerText="Datum Revisionsslut" />
                                    <SortableTableHeader propertyToSortBy="Last101TreatmentDate" headerText="Senaste 101" />
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    data.length > 0
                                        ? data.map((patient, key) => {
                                            return (
                                                <tr className="clickable-row align-text-bottom" key={key} >
                                                    <td className="table-data-link">{goToPatientLink(formatPersonalSecurityNumberAndOrganisationNumber(patient.personalSecurityId), patient.patientGuidId)}</td>
                                                    <td className="table-data-link">{goToPatientLink(patient.name, patient.patientGuidId)}</td>
                                                    <td className="table-data-link">{goToPatientLink(patient.address, patient.patientGuidId)}</td>
                                                    <td className="table-data-link">{goToPatientLink(patient.treatmentReportStarted ? "Ja" : "Nej", patient.patientGuidId)}</td>
                                                    <td className="text text-right table-data-link">{goToPatientLink(dateTimeToDateString(patient.listingDate), patient.patientGuidId)}</td>
                                                    <td className="text text-right table-data-link">{goToPatientLink(patient.revisionEndDate ? dateTimeToDateString(patient.revisionEndDate) : "Saknas", patient.patientGuidId)}</td>
                                                    <td className="text text-right table-data-link">{goToPatientLink(patient.last101TreatmentDate ? dateTimeToDateString(patient.last101TreatmentDate) : "-", patient.patientGuidId)}</td>
                                                </tr>
                                            )
                                        })
                                        : <tr><td colSpan={7}>Det finns inga patienter att visa</td></tr>
                                }
                            </tbody>
                        </Table>
                    </section>
                    : null
            }
        </>
    )
}